import React from 'react';
import AtsTooltip from 'ats/components/ats-tooltip/AtsTooltip';
import EllipsisTooltipLabel from 'ats/components/ellipsis-tooltip-label/EllipsisTooltipLabel';
import JobApplicationStageIcon from 'ats/components/job-application-stage-icon/JobApplicationStageIcon';
import { getJobApplicationStageTheme } from 'ats/constants/jobApplicationStageTheme';

export default function JobApplicationStageLabel({
	stageData,
	statusData,
	showStatusTooltip = false,
	truncate = false
}) {
	const stage = stageData?.value;
	const theme = getJobApplicationStageTheme(stage);
	const rootClassName = [
		'job-application-stage-label is-flex is-align-items-center gap-2',
		truncate ? 'job-application-stage-label--truncate' : ''
	]
		.filter(Boolean)
		.join(' ');

	return (
		<div className={rootClassName}>
			{showStatusTooltip && statusData?.label ? (
				<AtsTooltip text={statusData.label} placement="right">
					<JobApplicationStageIcon stage={stage} />
				</AtsTooltip>
			) : (
				<JobApplicationStageIcon stage={stage} />
			)}
			<EllipsisTooltipLabel
				wrapperClassName="job-application-stage-label__text-wrap"
				className="job-application-stage-label__text"
				text={stageData?.label}
				style={{ color: theme.color }}
			/>
		</div>
	);
}
